import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

const useSingleImageDrop = () => {
  const [selectedImage, setSelectedImage] = useState([]);
  const [isDropped, setIsDropped] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    const newImage = acceptedFiles[0];
    if (!newImage) return;

    const imageWithPreview = Object.assign(newImage, {
      preview: URL.createObjectURL(newImage),
    });

    setSelectedImage([imageWithPreview]);
    setIsDropped(true);
  }, []);

  const handleReplace = useCallback((file) => {
    if (!(file instanceof File)) {
      console.error("handleReplace received non-File:", file);
      return;
    }

    const updatedFile = Object.assign(file, {
      preview: URL.createObjectURL(file),
    });

    setSelectedImage([updatedFile]);
    setIsDropped(true);
  }, []);

  const handleDelete = useCallback(
    (previewToDelete) => {
      const updated = selectedImage.filter(
        (image) => image.preview !== previewToDelete
      );
      setSelectedImage(updated);
      if (updated.length === 0) setIsDropped(false);
    },
    [selectedImage]
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/*": [] },
    onDrop,
    maxFiles: 1,
  });

  return {
    selectedImage,
    isDropped,
    getRootProps,
    getInputProps,
    handleReplace,
    handleDelete,
    setSelectedImage,
    setIsDropped,
    onDrop,
  };
};

export default useSingleImageDrop;
